import {FC, useState} from 'react';
import {api, useT, useUploadQueue} from '@kcast-fe/core';
import {Box, Flex, Stack} from '@chakra-ui/react';
import {Loader, Modal, SearchInputBig} from 'ui-kit';

import {DocumentList, DocumentListHeader, DocumentUploader} from './components';

const MAX_WIDTH = {base: '796px', smToMd: 'calc(100% - 12px)'};
const GRID_TEMPLATE = {base: '40px 1fr 92px 120px 100px 36px', smToMd: '40px 1fr 92px 36px'};

const DocumentsSceneFC: FC = () => {
  const {isFetching} = api.documents.useDocumentsQuery();
  const uploadMutation = api.documents.useUploadDocumentMutation();

  const [query, setQuery] = useState('');
  const {queue, documentsQueue, queueActions} = useUploadQueue({upload: uploadMutation});

  const {t} = useT();

  return (
    <Modal isOpen isFullHeight title={t('common.files')} maxW={MAX_WIDTH}>
      <Box h={'calc(100% - 24px)'} data-testid={'DocumentModal'}>
        <Stack h={'100%'} gap={'0'} w={'100%'} overflowY={'hidden'}>
          <Flex
            gap={'24px'}
            p={'24px 24px 0 24px'}
            flexDirection={'column'}
            justifySelf={'flex-start'}
          >
            <SearchInputBig value={query} onChange={setQuery} />
            {/*<BreadCrumbs hideActive breadCrumbs={breadCrumbs} />*/}
            <DocumentListHeader gridTemplate={GRID_TEMPLATE} />
          </Flex>

          <Box p={'0 24px'} minH={'1px'} flex={'1 1 auto'} overflowY={'auto'}>
            {isFetching ? (
              <Loader isCenter size={'lg'} />
            ) : (
              <DocumentList
                query={query}
                queue={queue}
                gridTemplate={GRID_TEMPLATE}
                documentsQueue={documentsQueue}
              />
            )}
          </Box>

          <Box justifySelf={'flex-end'}>
            <DocumentUploader queue={queue} queueActions={queueActions} />
          </Box>
        </Stack>
      </Box>
    </Modal>
  );
};

export const DocumentsScene = DocumentsSceneFC;
